import React from 'react';
import './index.scss';

function Button({text = 'text', type = 'primary', onClick = () => {}}) {
  return (
    <button className={`f-build__button ${type}`} onClick={onClick}>
      {text}
    </button>
  );
}

export default Button;
